export enum EventSocketEnum {
  NEW_TERMS_CREATED_EVENT = "NEW_TERMS_CREATED_EVENT",
  NEW_TERMS_EDITED_EVENT = "NEW_TERMS_EDITED_EVENT",
  NEW_TERMS_APPLIED = "NEW_TERMS_APPLIED",
  RECOMMENDATION_CREATED_EVENT = "RECOMMENDATION_CREATED_EVENT",
  RECOMMENDATION_EDITED_EVENT = "RECOMMENDATION_EDITED_EVENT",
  RECOMMENDATION_CLOSED = "RECOMMENDATION_CLOSED",
  TRAFFIC_REQUEST_DELETED_EVENT = "TRAFFIC_REQUEST_DELETED_EVENT"
}